import React, { useState, useEffect, forwardRef, Fragment, useImperativeHandle } from "react";
import { useHistory } from "react-router-dom";
import {TextField,
        Grid,
        Box,
        Button,
        CircularProgress,
        Typography,
        InputAdornment,
        NativeSelect,
        FormHelperText,
        FormControl,
        InputLabel,
        Switch,
        Link
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddressAutoComplete from '../../components/AddressAutoComplete/AddressAutoComplete';
import { useUserState, sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import config from '../../config'
import {DropzoneArea} from 'material-ui-dropzone'

import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import GradeIcon from '@material-ui/icons/Grade';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import StyleIcon from '@material-ui/icons/Style';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import FaceIcon from '@material-ui/icons/Face';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PublishIcon from '@material-ui/icons/Publish';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import MapIcon from '@material-ui/icons/Map';
import LocationCityIcon from '@material-ui/icons/LocationCity';

import './UpdateAccount.css'


const UpdateAccount = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const {  onFormUpdated, onAccountUpdated, onPhotoUploaded } = props

    const classes = useStyles();
    const history = useHistory();
    var { regions, geo_regions } = useUserState();

    const [selectedHomeGeoRegionId, setSelectedHomeGeoRegionId] = useState(-1);
    const [geoRegionOptions, setGeoRegionOptions] = useState([]);

    const [account, setAccount] = useState(props.account === undefined || props.account === null ? {level: 1, active: true, proof_access: false, settings:{}} :  props.account);
    const [selectedLevel, setSelectedLevel] = useState(1);
    const [noLevelSelectedError, setNoLevelSelectedError] = useState(null);
    const [customerOptionsOpen, setCustomerOptionsOpen] = useState(false);
    const [customerOptions, setCustomerOptions] = useState([]);
    const customerOptionsLoading = customerOptionsOpen && customerOptions.length === 0;
    const [customerValue, setCustomerValue] = useState(null);
    const [customerInputValue, setCustomerInputValue] = useState('');
    const [workers, setWorkers] = useState([]);
    const [selectedAccountType, setSelectedAccountType] = useState('Administrator');
    const [selectedAdminAccess, setSelectedAdminAccess] = useState('Customer Service');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordDifferentError, setPasswordDifferentError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [fileObjects, setFileObjects] = useState([]);
    const [noRegionSelectedError, setNoRegionSelectedError] = useState(false);
    const [selectedRegionId, setSelectedRegionId] = useState(-1);
    const [regionOptions, setRegionOptions] = useState([]);
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    const test = [{name:"fire_kit", label: "Fire Kit", type:'swtich'}, {name:"thermal_trained", label:"Thermal Trained", type:'switch'}];

    useImperativeHandle(ref, () => ({
      uploadAccountPhoto(id) {
        setAccount({
          ...account,
          id: id
        });
        onUploadAccountPhoto(id);
      },
    }));


    useEffect(() => {
        let mounted = true;
        var tempAccountType = ""
        const fetchCustomerById = async(id) => {
          const response = await ttAPI.getCustomerById(id);
          if(mounted){
             setCustomerValue(response.name);
          }
        };
      if (account !== undefined && account !== null) {
          if (account.account_access !== undefined && account.account_access !== null && account.account_access) {
                setSelectedAdminAccess('Administrator');
          }
          else if (account.franchise_access !== undefined && account.franchise_access !== null && account.franchise_access) {
                setSelectedAdminAccess('Region Manager');

          } else if (account.customer_access !== undefined && account.customer_access !== null && account.customer_access) {
                setSelectedAdminAccess('Customer Service');
          }

          if ((account.account_access === undefined || account.account_access === null || !account.account_access) &&
              (account.franchise_access === undefined || account.franchise_access === null || !account.franchise_access) &&
              (account.customer_access === undefined || account.customer_access === null || !account.customer_access)) {
                if (account.customer_id === undefined || account.customer_id === null /*|| account.customer_id <= 0*/) {
                    tempAccountType = 'Technician';
                    setSelectedAccountType(tempAccountType);

                    if (account.franchise_id !== undefined && account.franchise_id > 0) {
                        setSelectedRegionId(account.franchise_id);
                    }

                    if (account.level !== undefined && account.level > 0 && account.level < 6) {
                        setSelectedLevel(account.level);
                    }

                    if (account.home_geo_region_id !== undefined && account.home_geo_region_id > 0) {
                        setSelectedHomeGeoRegionId(account.home_geo_region_id);
                    }
                }
                else {
                    tempAccountType = 'Customer';
                    setSelectedAccountType(tempAccountType);
                    if (account.customer_id !== undefined && account.customer_id != null && account.customer_id > 0 &&
                        (customerValue === undefined || customerValue === null || customerValue ==='')) {
                          fetchCustomerById(account.customer_id);

                    }
                }
          }
          else {
              tempAccountType = 'Administrator';
              setSelectedAccountType(tempAccountType);
              if (account.customer_id !== undefined && account.customer_id != null && account.customer_id > 0 &&
                  (customerValue === undefined || customerValue === null || customerValue ==='')) {
                    fetchCustomerById(account.customer_id);
              }
              else if (account.franchise_id !== undefined && account.franchise_id > 0) {
                     setSelectedRegionId(account.franchise_id);
              }
          }

          if (account.name !== undefined && account.name !== null && account.name !== '' &&
              account.signon !== undefined && account.signon !== null && account.signon !== '' &&
              account.email !== undefined && account.email !== null && account.email !== '') {
                if (tempAccountType === 'Technician' && (account.phone === undefined || account.phone === null || account.phone === '')) {
                      onFormUpdated(false);
                }
                else {
                      if ((account.password !== undefined && account.password !== null && account.password !== '' &&
                          !confirmPasswordError && !passwordDifferentError) ||
                          (account.password === undefined || account.password === null || account.password === '')) {
                            if (tempAccountType === 'Technician') {
                                onFormUpdated(account.level !== undefined && account.level !== null && account.level > 0 && account.level < 6 &&
                                              account.franchise_id !== undefined && account.franchise_id !== null && account.franchise_id > 0);
                            }
                            else if (tempAccountType === 'Administrator') {
                                onFormUpdated(true);
                            }
                            else if (tempAccountType === 'Customer') {
                                onFormUpdated(account.customer_id !== undefined && account.customer_id !== null && account.customer_id > 0);
                            }
                            else {
                                onFormUpdated(false);
                            }
                      }
                      else {
                          onFormUpdated(false);
                      }
                }


          }
          else {
            onFormUpdated(false);
          }

        onAccountUpdated(account);

        return () => mounted = false;
      }
    }, [account]);

    useEffect(() => {
      let active = true;

      /*if (!descriptionOptionsLoading) {
        return undefined;
      }*/

      (async () => {
        const response = await ttAPI.getCustomersByKey(customerInputValue);

        if (active) {
          setCustomerOptions(response);
        }
      })();

      return () => {
        active = false;
      };
    }, [customerOptionsLoading, customerInputValue]);

    useEffect(() => {
      var tempRegions = [];
      tempRegions.push(<option key="0" aria-label="None" value="" />);
      if (regions !== undefined) {
          regions.map(region => {
            if (region.id) {
              tempRegions.push(<Fragment key={region.id}><option value={region.id}>{region.name}</option></Fragment>)
            }
            return tempRegions;
          });
      }
      setRegionOptions(tempRegions);
    }, [regions]);

    useEffect(() => {
        if (password !== undefined && password !== null && password !== '' &&
            !confirmPasswordError && !passwordDifferentError) {
              setAccount({
                ...account,
                password: password
              });
        }

    }, [confirmPasswordError, passwordDifferentError, password]);

    useEffect(() => {
      var tempGeoRegions = [];
      tempGeoRegions.push(<option key="0" aria-label="None" value="" />);
      if (geo_regions !== undefined) {
          geo_regions.map(geo_region => {
            if (geo_region.id) {
              tempGeoRegions.push(<Fragment key={geo_region.id}><option value={geo_region.id}>{geo_region.name}</option></Fragment>)
            }
            return tempGeoRegions;
          });
      }
      setGeoRegionOptions(tempGeoRegions);
    }, [geo_regions]);

    function handleChange(e) {
      setAccount({
        ...account,
        [e.target.name]: e.target.value,
      });
    }

    function handleChangeSelectLevel(e) {
      setAccount({
        ...account,
        level:  parseInt(e.target.value),
      });
      setSelectedLevel(e.target.value);
    }

    function onBlurLevelSelection() {
      validateLevel();
    }

    function validateLevel() {
      setNoLevelSelectedError(selectedLevel === undefined || selectedLevel === null || selectedLevel <= 0 || selectedLevel > 5);
    }

    function handleChangeAccountType(e) {
      setSelectedAccountType(e.target.value);

      if (e.target.value === 'Administrator') {
          setAccount({
            ...account,
            level:  -1,
            customer_id: -1,
            account_access: true,
            franchise_access: true,
            customer_access: true
          });
          setCustomerValue(null);
      }
      else if (e.target.value === 'Technician') {
          setAccount({
            ...account,
            account_access: false,
            customer_access:  false,
            franchise_access:  false,
            customer_id: null,
            level: 1
          });
          setCustomerValue(null);
      }
      else if (e.target.value === 'Customer') {
        setAccount({
          ...account,
          level:  -1,
          customer_id: 0,
          customer_access:  false,
          franchise_access:  false,
          account_access:  false,
        });
      }
    }

    function handleChangeAdminAccess(e) {
        setSelectedAdminAccess(e.target.value);
        setSelectedRegionId(-1);
        setCustomerValue(null);
        if (e.target.value === 'Administrator') {
          setAccount({
            ...account,
            account_access: true,
            franchise_access: true,
            customer_access: true,
          });
        }
        else if (e.target.value === 'Customer Service') {
          setAccount({
            ...account,
            account_access: false,
            franchise_access: false,
            customer_access: true,
            franchise_id: -1,
            customer_id: -1
          });
        }
        else if (e.target.value === 'Region Manager') {
          setAccount({
            ...account,
            account_access: false,
            franchise_access: true,
            customer_access: false
          });
        }

    }
    function handleChangePassword(e) {
        setPassword(e.target.value);
        setConfirmPasswordError((confirmPassword === undefined || confirmPassword === null || confirmPassword === '') && (e.target.value !== undefined && e.target.value !== null && e.target.value !== ''));
        setPasswordDifferentError(
          e.target.value !== undefined && e.target.value !== null && e.target.value !== ""  &&
          confirmPassword !== undefined && confirmPassword !== null && confirmPassword !== ""  &&
          e.target.value !== confirmPassword);
    }

    function handleChangeConfirmationPassword(e) {
        setConfirmPassword(e.target.value);
        setConfirmPasswordError((e.target.value === undefined || e.target.value === null || e.target.value === '') && (password !== undefined && password !== null && password !== ''));
        setPasswordDifferentError(
          password !== undefined && password !== null && password !== ""  &&
          e.target.value !== undefined && e.target.value !== null && e.target.value !== ""  &&
          password !== e.target.value);

    }

    function onBlurPassword() {
        setPasswordDifferentError(
          password !== undefined && password !== null && password !== ""  &&
          confirmPassword !== undefined && confirmPassword !== null && confirmPassword !== ""  &&
          password !== confirmPassword);
    }

    function updateCustomer(customerId) {
      setAccount({
        ...account,
        customer_id: customerId
      });
    }

    const onUploadAccountPhoto = async (newId) => {
        setIsUploading(true);
        if ( window.FileReader && window.FormData && fileObjects !== null && fileObjects !== undefined && fileObjects.length > 0) {
           var formData = new FormData();
           var reader = new FileReader();
           // read
           reader.onload = async function(e) {
               var fileName = fileObjects[0].name;
               if (formData) {
                   formData.append('files[]', fileObjects[0], fileName);
                   var idToUse = account.id === undefined || account.id === null || account.id <= 0 ? newId : account.id;
                   const response = await ttAPI.uploadAccountPhoto(idToUse, formData);
                   setIsUploading(false);
                   if (response) {
                     sendNotification('success', 'Success - Account Photo Uploaded.', classes);
                     history.push({pathname:`/app/account/edit/${idToUse}`,
                                              state:{accountId: idToUse}
                                            });
                   }
                   else {
                     sendNotification('error', 'Error - Error Uploading Account Photo.', classes);
                   }
                   onPhotoUploaded();
               }

           };
           reader.readAsDataURL(fileObjects[0]);

       }

    }

    function handleChangeRegion(e) {
      setAccount({
        ...account,
        franchise_id: e.target.value === '' ? -1 : e.target.value,
      });
      setSelectedRegionId(e.target.value);
    }

    function onBlurRegionSelection() {
      validateRegion();
    }

    function validateRegion() {
      var noRegionIdSelected = selectedRegionId === undefined || selectedRegionId === null || selectedRegionId <= 0
      var correctAccountTypeAndAccess = selectedAccountType === 'Technician' || (selectedAccountType === 'Administrator' && selectedAdminAccess === 'Region Manager');
      setNoRegionSelectedError(noRegionIdSelected && correctAccountTypeAndAccess);
    }

    function onClickArchiveSwitch() {
        setAccount({
          ...account,
          active: account.active === undefined || account.active === null ? false : !account.active
        });
    }

    function onClickVaccinationProofSwitch() {
        setAccount({
          ...account,
          proof_access: account.proof_access === undefined || account.proof_access === null ? false : !account.proof_access
        });
    }

    function onClickTechnicianSettingSwitch(item) {
      var settings = account.technician_settings;
      if (settings === undefined || settings === null) {
          settings = {};
          settings[item.name] = true;
      }
      else {
          if (settings[item.name] === undefined || settings[item.name] === null) {
              settings[item.name] = true;
          }
          else {
              settings[item.name] = !settings[item.name];
          }
      }

      setAccount({
        ...account,
        technician_settings: settings
      });
    }

    function onChangeSettingText(e, item) {
      var settings = account.technician_settings;
      if (settings === undefined || settings === null) {
          settings = {};
          settings[item.name] = e.target.value;
      }
      else {
          settings[item.name] = e.target.value;
      }

      setAccount({
        ...account,
        technician_settings: settings
      });
    }

    function onClickFireKitSwitch() {
        var settings = account.technician_settings;
        if (settings === undefined || settings === null) {
            settings = {fire_kit:true};
        }
        else {
            if (settings.fire_kit === undefined || settings.fire_kit === null) {
                settings.fire_kit = true;
            }
            else {
                settings.fire_kit = !settings.fire_kit;
            }
        }

        console.log('onClickFireKitSwitch',settings)

        setAccount({
          ...account,
          technician_settings: settings
        });
    }



    const isEmailValid = () => {
      if (account === null || account === undefined ||
          account.email === null || account.email === undefined || account.email === '') {
        return true;
      }
      var isValid = pattern.test(account.email);
      return isValid;
    }


    const getRandomInt = (max) => {
      return Math.floor(Math.random() * Math.floor(max));
    }

    function onGeoLocationFetched(geolocation, item) {//console.log('onGeoLocationFetched',geolocation, item.name )
      /*setNewCustomer({
        ...newCustomer,
        mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
      });*/

      var settings = account.technician_settings;
      if (settings === undefined || settings === null) {
          settings = {};
          settings[item.name] = geolocation[item.name];
      }
      else {
          settings[item.name] = geolocation[item.name];
      }

      setAccount({
        ...account,
        technician_settings: settings
      });
    }

    function onSelectAddress(address,item) {
        var settings = account.technician_settings;
        if (settings === undefined || settings === null) {
            settings = {};
            settings[item.name] = address;
        }
        else {
            settings[item.name] = address;
        }

        setAccount({
          ...account,
          technician_settings: settings
        });
    }

    function onSelectHomeAddress(homeAddress) {
      setAccount({
        ...account,
        home_address: homeAddress
      });
    }

    function onHomeGeoLocationFetched(geolocation) {
      var geoRegion = geo_regions.find(geo_region => geolocation.region.toUpperCase() === 'Manawatu-Wanganui' ? 'Manawatū-Whanganui' === geo_region : geolocation.region.toUpperCase() === geo_region.name.toUpperCase());
      var geoRegionId = geoRegion !== undefined && geoRegion !== null ? geoRegion.id : -1;
      setSelectedHomeGeoRegionId(geoRegionId);
      setAccount({
        ...account,
        home_geo_region_id: geoRegionId,
        home_geo_locality: geolocation.locality,
        home_mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
      });
    }

    function handleChangeHomeGeoRegion(e) {
      setAccount({
        ...account,
        home_geo_region_id: e.target.value === '' ? -1 : e.target.value,
      });
      setSelectedHomeGeoRegionId(e.target.value);
    }

  return (account && <>
    <div className={classes.contentDiv}>

        <Grid container spacing={4}>
          <Grid item xs={12} md={12} sm={12}>
              <div className={classes.formDisplay}>
                <div className={classes.inline}>
                  <TextField
                    required
                    id="name"
                    label="Name"
                    autoComplete='off'
                    onChange={handleChange}
                    name="name"
                    value={account.name || ''}
                    variant="outlined"
                    size="small"
                    style={{ marginBottom: 20 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />

                  {selectedAccountType === 'Technician' &&
                  <FormControl variant="outlined" className={classnames({
                        'select-control': true
                      })}>
                    <InputLabel id="level-label">Level<sup>*</sup></InputLabel>
                    <div className={classnames({
                                  [classes.error]: noLevelSelectedError,
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <GradeIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedLevel}
                        onChange={handleChangeSelectLevel}
                      >
                         <option disabled value="-1"> -- select an option -- </option>
                         <option value="1">Level 1</option>
                         <option value="2">Level 2</option>
                         <option value="3">Level 3</option>
                         <option value="4">Level 4</option>
                         <option value="5">Level 5</option>
                      </NativeSelect>
                    </div>
                  </FormControl>}
                </div>

              <TextField
                required
                id="signon"
                label="Signon"
                autoComplete='off'
                onChange={handleChange}
                name="signon"
                value={account.signon || ''}
                variant="outlined"
                size="small"
                style={{ marginBottom: 20 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ExitToAppIcon />
                    </InputAdornment>
                  ),
                }}
              />

              <div className={classes.inline}>
                  <TextField
                    required
                    id="email"
                    label="Email"
                    autoComplete='off'
                    onChange={handleChange}
                    value={account.email || ''}
                    name="email"
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    type={'email'}
                    size="small"
                    error={!isEmailValid()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    required={selectedAccountType === 'Technician'}
                    id="phone"
                    label="Phone"
                    autoComplete='off'
                    onChange={handleChange}
                    value={account.phone || ''}
                    name="phone"
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    type={'phone'}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
              </div>

              <div className={classes.inline}>
                  <TextField
                      id="password"
                      label="New Password"
                      variant="outlined"
                      size="small"
                      name="newPassword"
                      value={password || ''}
                      onChange={handleChangePassword}
                      onBlur={onBlurPassword}
                      error={passwordDifferentError}
                      helperText={passwordDifferentError !== null && passwordDifferentError !== undefined && passwordDifferentError ? 'The confirm password does not match.' : ' '}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyIcon />
                          </InputAdornment>
                        ),
                      }}
                  />
                  <TextField
                      id="confirm-password"
                      variant="outlined"
                      size="small"
                      label="Confirm Password"
                      value={confirmPassword || ''}
                      name="confirmPassword"
                      error={confirmPasswordError}
                      onChange={handleChangeConfirmationPassword}
                      onBlur={onBlurPassword}
                      helperText={confirmPasswordError !== null && confirmPasswordError !== undefined && confirmPasswordError ? 'Please confirm your password.' : ' '}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyIcon />
                          </InputAdornment>
                        ),
                      }}
                  />
              </div>

              {/*<Box display={"flex"} alignItems={"center"}  style={{ marginBottom: 20 }}>
                  <Switch color={"primary"} checked={account.proof_access}
                          onClick={onClickVaccinationProofSwitch} />
                  <Typography weight={"medium"}>
                      Happy to provide proof of Vaccination
                  </Typography>
              </Box>*/}


              <FormControl style={{marginBottom: 20}} variant="outlined" className={classnames({
                    'select-control': true
                  })}>
                <InputLabel id="account_type">Account Type<sup>*</sup></InputLabel>
                <div className={classnames({
                              'select-control-input': true
                            })}>
                  <InputAdornment position="start">
                    <StyleIcon />
                  </InputAdornment>
                  <NativeSelect
                    value={selectedAccountType}
                    onChange={handleChangeAccountType}
                  >
                     <option disabled value="-1"> -- select an option -- </option>
                     <option value="Administrator">Administrator</option>
                     <option value="Technician">Technician</option>
                     <option value="Customer">Customer</option>
                  </NativeSelect>
                </div>
              </FormControl>

              {selectedAccountType === 'Administrator' &&
              <FormControl style={{marginBottom: 20}} variant="outlined" className={classnames({
                    'select-control': true
                  })}>
                <InputLabel id="admin_access">Admin Access<sup>*</sup></InputLabel>
                <div className={classnames({
                              'select-control-input': true
                            })}>

                  <InputAdornment position="start">
                    <SupervisorAccountIcon />
                  </InputAdornment>
                  <NativeSelect
                    value={selectedAdminAccess}
                    onChange={handleChangeAdminAccess}
                  >
                     <option disabled value="-1"> -- select an option -- </option>
                     <option value="Customer Service">Customer Service</option>
                     <option value="Region Manager">Region Manager</option>
                     <option value="Administrator">Administrator</option>
                  </NativeSelect>
                </div>
              </FormControl>}

              {(selectedAccountType === 'Customer') &&
                <Autocomplete
                  freeSolo
                  id="customer"
                  noOptionsText="Type to search customer"
                  options={customerOptions}
                  loading={customerOptionsLoading}
                  getOptionLabel={(option) => option.id === undefined || option.id === null ? option : `${option.id} - ${option.name} - ${option.company}`}
                  style={{ marginBottom: 20}}
                  getOptionSelected={(option, value) => value.id === undefined || value.id === null ? value === option.value : (option.id === value.id)}
                  onInputChange={(event, newInputValue) => {
                    setCustomerInputValue(newInputValue);
                  }}
                  onChange={(event, value) => {
                    if (value !== undefined && value !== null) {

                        updateCustomer(value.id);
                    }
                    else  {
                        updateCustomer(-1);
                    }
                  }}
                  value={customerValue}
                  open={customerOptionsOpen}
                  onOpen={() => {
                    setCustomerOptionsOpen(true);
                  }}
                  onClose={() => {
                    setCustomerOptionsOpen(false);
                  }}
                  renderInput={(params) => <TextField
                        {...params}
                        required
                        label="Customer"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaceIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <Fragment>
                              {customerOptionsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </Fragment>
                          ),
                        }}
                      />}
                />}

                {selectedAccountType === 'Administrator' && selectedAdminAccess === 'Administrator' &&  <div>You only need to set a region if you want to use this admin account to work on a job.</div>}
                {(selectedAccountType === 'Technician' || (selectedAccountType === 'Administrator' && (selectedAdminAccess === 'Region Manager' || selectedAdminAccess === 'Administrator'))) &&

                  <FormControl variant="outlined" style={{ marginBottom: 20}}
                                className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control': true
                                })}>
                    <InputLabel id="region">Region{(selectedAccountType === 'Technician' || (selectedAccountType === 'Administrator' && selectedAdminAccess === 'Region Manager')) && <sup>*</sup>}</InputLabel>
                    <div className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <HomeWorkIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedRegionId}
                        onChange={handleChangeRegion}
                        onBlur={onBlurRegionSelection}
                      >
                         {regionOptions}
                      </NativeSelect>
                    </div>
                    {noRegionSelectedError && <FormHelperText className={classes.error}>You must select a region!</FormHelperText>}

                    {/*<Box display={"flex"} alignItems={"center"}  style={{ marginBottom: 20 }}>
                        <Switch color={"primary"} checked={account.technician_settings === undefined || account.technician_settings === null ? false : (account.technician_settings.fire_kit === undefined || account.technician_settings.fire_kit === null ? false : account.technician_settings.fire_kit)}
                                onClick={onClickFireKitSwitch} />
                        <Typography weight={"medium"}>
                            Fire Kit
                        </Typography>
                    </Box>*/}
                  </FormControl>
                }

                {selectedAccountType === 'Technician' && <FormControl style={{ marginBottom: 20 }}>
                      <h4>Equipment</h4>
                      {props.technicianSettingsSetups.map((item) => {
                        if (item.type !== 'switch' || item.category !== 'equipment')
                            return null;
                        return (
                        <Box display={"flex"} alignItems={"center"}>
                            <Switch color={"primary"} checked={account.technician_settings === undefined || account.technician_settings === null ? false : (account.technician_settings[item.name] === undefined || account.technician_settings[item.name] === null ? false : account.technician_settings[item.name])}
                                    onClick={() => onClickTechnicianSettingSwitch(item)}/>
                            <Typography weight={"medium"}>
                                {item.label}
                            </Typography>&nbsp;
                            <img style={{width:'25px', height:'25px'}} src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/tssp/${item.id}`} alt={`${item.label}`} title={`${item.label}`}/>
                        </Box>
                      );
                    })} </FormControl>}

                    {selectedAccountType === 'Technician' && <FormControl style={{ marginBottom: 20 }}>
                          <h4>Training</h4>
                          {props.technicianSettingsSetups.map((item) => {
                            if (item.type !== 'switch' || item.category !== 'training')
                                return null;
                            return (
                            <Box display={"flex"} alignItems={"center"}>
                                <Switch color={"primary"} checked={account.technician_settings === undefined || account.technician_settings === null ? false : (account.technician_settings[item.name] === undefined || account.technician_settings[item.name] === null ? false : account.technician_settings[item.name])}
                                        onClick={() => onClickTechnicianSettingSwitch(item)}/>
                                <Typography weight={"medium"}>
                                    {item.label}
                                </Typography>&nbsp;
                                <img style={{width:'25px', height:'25px'}} src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/tssp/${item.id}`} alt={`${item.label}`} title={`${item.label}`}/>
                            </Box>
                          );
                        })} </FormControl>}

                      {selectedAccountType === 'Technician' &&
                          <div style={{ marginBottom: 20 }}>
                              <h4>Base Location</h4>
                              <AddressAutoComplete presetValue={account.home_address} onSelect={onSelectHomeAddress} onLocationUpdate={onHomeGeoLocationFetched}/>
                              <FormControl variant="outlined" style={{ marginBottom: 20}}
                                            className={classnames({
                                              'select-control': true
                                            })}>
                                <InputLabel id="home_geo_region">Home Geographic Region</InputLabel>
                                <div className={classnames({
                                              'select-control-input': true
                                            })}>
                                  <InputAdornment position="start">
                                    <MapIcon />
                                  </InputAdornment>
                                  <NativeSelect
                                    value={selectedHomeGeoRegionId}
                                    onChange={handleChangeHomeGeoRegion}
                                  >
                                     {geoRegionOptions}
                                  </NativeSelect>
                                  {/*<FormHelperText>Result returned from GeoAPI: {account.geo_region_name}</FormHelperText>*/}
                                </div>
                              </FormControl>

                              <TextField
                                  id="home_geo_locality"
                                  label="Home Geographic Locality"
                                  autoComplete='off'
                                  onChange={handleChange}
                                  style={{ width: '100%' }}
                                  name="home_geo_locality"
                                  value={account.home_geo_locality || ''}
                                  variant="outlined"
                                  size="small"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <LocationCityIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />

                                {account.home_mapurl !== null && account.home_mapurl !== undefined && account.home_mapurl !== '' &&
                                <Link href={account.home_mapurl} target="_blank"
                                      style={{marginLeft: '10px', fontSize: '16px', textDecoration: 'underline', marginTop: '10px'}}>
                                        View Map
                                </Link>}
                          </div>}
                      {/*}<FormControl style={{ marginBottom: 20 }}>
                            <h4>Location</h4>

                            {props.technicianSettingsSetups.map((item) => {
                              if (item.type !== 'address_autocomplete' || item.category !== 'location')
                                  return null;
                              return (


                                <AddressAutoComplete
                                 placeTypes="suburb_city"
                                 label="Suburb"
                                 presetValue={account.technician_settings === undefined || account.technician_settings === null ? '' : (account.technician_settings[item.name] === undefined || account.technician_settings[item.name] === null ? '' : account.technician_settings[item.name])}
                                 onSelect={(address) => onSelectAddress(address,item)}
                                 onLocationUpdate={(geolocation) => onGeoLocationFetched(geolocation, item)}/>
                            );
                          })} </FormControl>*/}


                <hr style={{width: '100%', marginBottom: '20px'}}/>
                <div className={classes.inline}>
                {account !== null && account !== undefined && account.id != '' && account.id > 0 &&
                  <img className={classes.accountImage}
                       src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${account.id}?${getRandomInt(1000000)}`}/>
                }
                <div className={classnames({
                                         'account-dragdrop': true
                                       })}>
                <DropzoneArea
                          filesLimit={1}
                          showFileNames={true}
                          acceptedFiles={['image/jpeg', 'image/png']}
                          dropzoneText={"Drag and drop an account image here or click."}
                          onChange={ newFileObjs => {setFileObjects(newFileObjs); }}
                          onDelete={ newFileObjs => {setFileObjects([]); }}
                          maxFileSize={2097152}
                        />

                        {fileObjects !== undefined && fileObjects !== null &&
                          fileObjects.length > 0 &&
                          <Button onClick={onUploadAccountPhoto}
                                  className={classes.uploadPhotoButton}
                                  variant="contained"
                                  color="primary"
                                  disabled={account == null || account == undefined || account.id === undefined || account.id === null || account.id <= 0}
                                  style={{ width: '100%' }}>

                            <Box>
                                <PublishIcon />
                            </Box>
                            {isUploading && <span><CircularProgress size={25}/> Uploading...</span>}
                            {!isUploading && <span>Upload</span>}
                        </Button>}
                        </div>
                </div>

                {(account !== null && account !== undefined && account.id !== undefined && account.id !== null && account.id > 0) &&
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography weight={"medium"}>
                        Archived
                    </Typography>
                    <Switch color={"primary"} checked={!account.active}
                            onClick={onClickArchiveSwitch} />
                </Box>}


              </div>
          </Grid>

        </Grid>
    </div></>
  );
//}
});
export default UpdateAccount;
